import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import { useDeliveryLocations } from "../useDeliveryLocations";
import { requestCreateDeliveryLocation } from "./updateDeliveryLocation.request";
import { UpdateDeliveryLocationBody } from "./updateDeliveryLocation.types";

const useUpdateDeliveryLocation = (
  options?: MutationOptions<
    void,
    ApiServiceError<ApiError>,
    UpdateDeliveryLocationBody
  >
) => {
  const { t } = useTranslation();

  const { refetch: refetchDeliveryLocations } = useDeliveryLocations({
    enabled: false
  });

  return useMutation({
    mutationFn: requestCreateDeliveryLocation,
    ...options,
    onSuccess: (data, variables, context) => {
      const getToastMessage = () => {
        if (variables.existingCountryName && variables.newCountryName) {
          return t("Country updated successfully");
        }

        if (variables.existingCityName && variables.newCityName) {
          return t("City updated successfully");
        }

        return t("Area updated successfully");
      };

      refetchDeliveryLocations();
      toast.success(getToastMessage());
      options?.onSuccess?.(data, variables, context);
    }
  });
};

export default useUpdateDeliveryLocation;
